import findKey from 'lodash.findkey';

class Locales {
    /**
     * get list with codes of site locales
     * @returns {string[]} array with locales
     */
    static getLocalesSite() {
        return ['EN', 'ES', 'DE', 'IT', 'FR', 'RU', 'NL'];
    }

    /**
     * get list of europe locales
     * @returns {string[]} array with locales
     */
    static getLocalesEurope() {
        return [
            'AD',
            'AL',
            'AT',
            'AX',
            'BA',
            'BE',
            'BG',
            'BY',
            'CH',
            'CS',
            'CZ',
            'DA',
            'DE',
            'DK',
            'EE',
            'ES',
            'FI',
            'FO',
            'FR',
            'GB',
            'GG',
            'GI',
            'GR',
            'HR',
            'HU',
            'IE',
            'IM',
            'IS',
            'IT',
            'JE',
            'LI',
            'LT',
            'LU',
            'LV',
            'MC',
            'MD',
            'ME',
            'MK',
            'MT',
            'NL',
            'NO',
            'PL',
            'PT',
            'RO',
            'RS',
            'RU',
            'SE',
            'SI',
            'SJ',
            'SK',
            'SM',
            'SV',
            'UA',
            'VA'
        ];
    }

    /**
     * get list of north america locales
     * @returns {string[]} array with locales
     */
    static getLocalesNorthAmerica() {
        return ['US', 'CA'];
    }

    /**
     * get list of latin america locales
     * @returns {string[]} array with locales
     */
    static getLocalesLatinAmerica() {
        return [
            'PT',
            'BR',
            'AR',
            'BO',
            'CL',
            'CO',
            'CR',
            'EC',
            'SV',
            'GT',
            'HN',
            'MX',
            'NI',
            'PA',
            'PY',
            'PE',
            'PR',
            'UY',
            'VE',
            'BZ',
            'GY',
            'SR',
            'HT',
            'DO'
        ];
    }

    /**
     * Returns the preferred site language for user country
     * @param {string} country - code of user country
     * @returns {?string} - Preferred site language or null
     */
    static getLocaleByCountry(country) {
        const countries = {
            RU: ['BY', 'KZ', 'KG', 'RU', 'TM'],
            ES: [
                'AR',
                'BO',
                'CL',
                'CO',
                'CR',
                'CU',
                'DO',
                'EC',
                'SV',
                'GQ',
                'GT',
                'HN',
                'MX',
                'NI',
                'PA',
                'PY',
                'PE',
                'PR',
                'ES',
                'UY',
                'VE'
            ],
            'PT-BR': ['AO', 'BR', 'CV', 'TL', 'GW', 'MZ', 'PT', 'ST'],
            FR: [
                'BJ',
                'BF',
                'BI',
                'CM',
                'CF',
                'TD',
                'KM',
                'CD',
                'DJ',
                'GQ',
                'FR',
                'GA',
                'GN',
                'HT',
                'CI',
                'LU',
                'MG',
                'ML',
                'MC',
                'NE',
                'CG',
                'RW',
                'SN',
                'SC',
                'TG',
                'VU'
            ],
            NL: ['BE', 'NL'],
            DE: ['DE', 'AT', 'CH', 'LI'],
            IT: ['IT', 'SM'],
            JA: ['JP'],
            PL: ['PL'],
            KO: ['KR'],
            DA: ['DK'],
            SV: ['SE'],
            NO: ['NO'],
            MS: ['MY'],
            ID: ['ID']
        };
        const checkLocale = (locale) => locale.includes(country);

        return findKey(countries, checkLocale) || null;
    }

    /**
     * Returns code of site locale in uppercase
     * @returns {string} locale code
     */
    static getSiteLocale() {
        if ('pageParams' in window && 'locale' in window.pageParams) {
            return window.pageParams.locale.toUpperCase();
        }
        return 'EN';
    }

    /**
     * Checks the user's language to some of the languages site
     * @param {string} locale - checking locale
     * @returns {boolean} exist user locale in site
     */
    static existsLocaleInSite(locale) {
        const siteLocales = Locales.getLocalesSite();

        return siteLocales.some((element) => element === locale);
    }

    /**
     * Returns code of user locale
     * @returns {string} language code
     */
    static getUserLocale() {
        /**
         * position of locale in the navigator language string
         * @type {number}
         */
        const position = -2;
        let language = '';

        if (navigator.languages) {
            /**
             * if array (like as chrome) then give first language
             * @type {string}
             */
            language = navigator.languages[0];
        } else if (navigator.language) {
            language = navigator.language;
        } else if (navigator.userLanguage) {
            language = navigator.userLanguage;
        }
        language = language ? language.substr(position).toUpperCase() : 'EN';
        return language;
    }

    /**
     * Checks for the country in the European countries list
     * @param {string} locale - checking locale
     * @returns {boolean} is Europe
     */
    static checkEurope(locale) {
        const europeLocales = Locales.getLocalesEurope();

        return europeLocales.some((element) => element === locale);
    }

    /**
     * Checks for the country in the European countries list
     * @param {string} locale - checking locale
     * @returns {boolean} is North America
     */
    static checkNorthAmerica(locale) {
        const northAmericaLocales = Locales.getLocalesNorthAmerica();

        return northAmericaLocales.some((element) => element === locale);
    }

    /**
     * Checks for the country in the Latin America countries list
     * @param {string} locale - checking locale
     * @returns {boolean} is Latin America
     */
    static checkLatinAmerica(locale) {
        const latinAmericaLocales = Locales.getLocalesLatinAmerica();

        return latinAmericaLocales.some((element) => element === locale);
    }
}

export default Locales;



// WEBPACK FOOTER //
// ./assets/js/common/modules/locales.js